<div class="container-fluid pt-1">
  <app-room-details
    [roomData]="roomData"
  ></app-room-details>
</div>
